import React from 'react';
import { Lock, ShieldCheck, Mail } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { useUsage } from '../context/UsageContext';
import { useFreemium } from '../context/FreemiumContext';

/**
 * IAPaywall — bloqueo amigable cuando el período de exploración (7 días) finalizó.
 *
 * Uso:
 *   const { trialAccesoCompleto } = useUsage();
 *   if (!trialAccesoCompleto) return <IAPaywall feature="..." />;
 */
export default function IAPaywall({ feature = 'Esta función' }) {
    const { mensajeIA, trialExpirado } = useUsage();
    const { status } = useFreemium();
    // Mientras la ventana de contingencia global o la autorización individual
    // estén activas, NO mostrar el paywall de trial expirado.
    if (status?.global_access_override_active) return null;
    if (status?.user_access_grant_active) return null;

    const titulo = trialExpirado
        ? 'Tu período de exploración finalizó'
        : `${feature}: disponible con plan completo`;

    const mensajePrincipal = trialExpirado
        ? 'Hemos conservado todo tu trabajo, avances, evidencias y estrategia para que puedas continuar exactamente donde quedaste. Activa tu plan para seguir construyendo tu Portafolio con acompañamiento, inteligencia artificial y orientación estratégica.'
        : (mensajeIA || 'Esta función está disponible al activar tu plan.');

    return (
        <Card
            className="border-rose-200 bg-gradient-to-br from-rose-50/80 via-white to-amber-50/40"
            data-testid="ia-paywall"
        >
            <CardContent className="p-8 sm:p-10">
                <div className="mx-auto flex max-w-2xl flex-col items-start gap-5">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-rose-100">
                        <Lock className="h-6 w-6 text-rose-700" />
                    </div>
                    <div className="space-y-3">
                        <p className="font-heading text-lg font-bold text-slate-900">
                            {titulo}
                        </p>
                        <p className="text-sm text-slate-700 leading-relaxed">
                            {mensajePrincipal}
                        </p>
                        <p className="inline-flex items-center gap-1.5 text-xs text-slate-500">
                            <ShieldCheck className="h-3.5 w-3.5" />
                            Tu progreso permanece intacto. Podrás continuar exactamente donde quedaste.
                        </p>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-2 pt-2">
                        <Button
                            size="sm"
                            className="gap-1.5 bg-slate-900 hover:bg-slate-800"
                            onClick={() =>
                                window.dispatchEvent(
                                    new CustomEvent('open-soporte', {
                                        detail: {
                                            asunto: 'Activar plan Portafolio Digital Docente',
                                            mensaje:
                                                'Hola, me gustaría activar mi plan para continuar construyendo mi Portafolio.',
                                        },
                                    })
                                )
                            }
                            data-testid="ia-paywall-contact"
                        >
                            <Mail className="h-4 w-4" />
                            Continuar mi Portafolio
                        </Button>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}

